import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { confirmPasswordReset } from '../services/api';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

export const ResetPassword: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);

  const token = searchParams.get('token');
  const email = searchParams.get('email');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (password !== confirmPassword) {
      setMessage('Passwords do not match');
      return;
    }

    if (password.length < 6) {
      setMessage('Password must be at least 6 characters');
      return;
    }

    if (!/\d/.test(password)) {
      setMessage('Password must contain at least one number');
      return;
    }

    if (!token) {
      setMessage('Invalid reset link');
      return;
    }

    setIsLoading(true);
    setMessage('');
    
    try {
      await confirmPasswordReset(token, password);
      setIsSuccess(true);
      setMessage('Password reset successfully! You can now log in to the app.');
    } catch (error: any) {
      setMessage(error.message || 'Failed to reset password. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  if (isSuccess) {
    return (
      <div className="reset-password-page">
        <Header />
        <main className="main-content">
          <div className="success-container">
            <div className="success-icon">✅</div>
            <h1>Password Reset Successful!</h1>
            <p>Your password has been updated successfully.</p>
            <p>You can now log in to the Good Old Maps app with your new password.</p>
            <a href="/" className="btn btn-primary">Return to Home</a>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="reset-password-page">
      <Header />
      <main className="main-content">
        <div className="reset-container">
          <h1>Reset Your Password</h1>
          {email && <p className="email-display">For: {email}</p>}
          
          <form onSubmit={handleSubmit} className="reset-form">
            <div className="form-group">
              <label htmlFor="password">New Password</label>
              <input
                type="password"
                id="password"
                placeholder="Enter new password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={6}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="confirmPassword">Confirm Password</label>
              <input
                type="password"
                id="confirmPassword"
                placeholder="Confirm new password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                minLength={6}
              />
            </div>
            
            <button 
              type="submit" 
              className="btn btn-primary btn-full"
              disabled={isLoading}
            >
              {isLoading ? 'Resetting Password...' : 'Reset Password'}
            </button>
          </form>
          
          {message && (
            <div className={`message ${isSuccess ? 'success' : 'error'}`}>
              {message}
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};



































